<template>
  <Card v-if="!loading && repInfo" title="Personal Information" margin="mb-2">
      <div class="row g-3">
        <!-- Main Information -->
        <div class="col-md-6">
          <div class="card">
            <div class="card-stamp">
              <div class="card-stamp-icon bg-primary">
                <IconUserFilled size="64"></IconUserFilled>
              </div>
            </div>
            <div class="card-body">
              <div class="row align-items-center g-3">
                <template v-for="(item, index) in mainInfo" :key="index">
                  <div :class="item.class" v-if="item.value">
                    <div class="text-secondary">{{ item.label }}</div>
                    <div class="h3 m-0">{{ item.value }}</div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Additional Information -->
        <div class="col-md-6">
          <div class="card">
            <div class="card-stamp">
              <div class="card-stamp-icon bg-secondary">
                <IconSteeringWheelFilled size="64"></IconSteeringWheelFilled>
              </div>
            </div>
            <div class="card-body">
              <div class="row align-items-center g-3">
                <template v-for="(item, index) in additionalInfo" :key="index">
                  <div :class="item.class" v-if="item.value">
                    <div class="text-secondary">{{ item.label }}</div>
                    <div class="h3 m-0">{{ item.value }}</div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
  </Card>
</template>

<script setup>
import { computed } from "vue";
import {IconSteeringWheelFilled, IconUserFilled} from "@tabler/icons-vue"
import { Card } from "@/components/atomic";
import { isApprovedDriver } from "@/constants/staff.js";

const props = defineProps({
  repInfo: {
    type: Object,
    required: true,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const getValue = (obj, key, defaultValue = 'N/A') => {
  if (!obj || !key) return null;
  const value = obj[key];
  if (value === null || value === undefined || value === '#N/A' || value === 'null') {
    return defaultValue;
  }
  return value;
};

const mainInfo = computed(() => ([
  {
    label: 'Resort',
    value: getValue(props.repInfo, 'Resort'),
    class: 'col-12'
  },
  {
    label: 'Role',
    value: getValue(props.repInfo, 'Week Role'),
    class: 'col-6'
  },
  {
    label: 'Staff Type',
    value: getValue(props.repInfo, 'Staff Type'),
    class: 'col-6'
  },
  {
    label: 'Remit',
    value: getValue(props.repInfo, 'Week Remit', 'N/A'),
    class: 'col-12'
  },
  {
    label: 'Group',
    value: getValue(props.repInfo, 'Group'),
    class: 'col-6'
  },
  {
    label: 'Equipment Rental',
    value: getValue(props.repInfo, 'Equipment Rental', 'None'),
    class: 'col-6'
  }
]));

const additionalInfo = computed(() => ([
  {
    label: 'Driver Status',
    value: isApprovedDriver(props.repInfo) ? 'Driver' : 'Not a driver',
    class: 'col-12'
  },
  {
    label: 'Approved Vehicles',
    value: getValue(props.repInfo, 'Approved Vehicles'),
    class: 'col-12'
  }
]));
</script>